import { NeedsHistoryEntryDto } from '@act/shared/data-transfer-objects';
import { callsAppSelectors } from 'redux/slices/callsSlice';
import { userAppSelectors } from 'redux/slices/usersSlice';
import CollapsibleHistoryCard from './CollapsibleHistoryCard';
import { getHistoryEntryDateLine } from './history-card-helpers';
import { ListPlusIcon } from '@phosphor-icons/react';
import { StyledHistoryEntryDescription } from './history-display';

interface NeedCallHistoryEntryProps {
  historyEntry: NeedsHistoryEntryDto;
  editMode?: boolean;
}

export const NeedCallHistoryEntry = ({
  historyEntry,
}: NeedCallHistoryEntryProps) => {
  const call = callsAppSelectors.useSelectCallById(historyEntry.callId);
  const creator = userAppSelectors.useSelectUserById(call?.originator?.userId);
  const creatorName = creator?.name;

  return (
    <CollapsibleHistoryCard
      title={`Resource Called: ${historyEntry.resource.title}`}
      subtitle={getHistoryEntryDateLine(historyEntry?.createdAt, creatorName)}
      expandedContent={
        <StyledHistoryEntryDescription
          dateAndUser={getHistoryEntryDateLine(
            historyEntry?.createdAt,
            creatorName
          )}
          description={call?.note || ''}
        ></StyledHistoryEntryDescription>
      }
      icon={<ListPlusIcon />}
    />
  );
};
